import React from 'react';

/**
 * LogoToggle — switches between Axis and V-Tech letterhead on the sheet preview.
 * Props:
 *   value    — 'axis' | 'vtech'
 *   onChange — (value) => void
 */
const LogoToggle = ({ value, onChange }) => (
    <div className="flex rounded-lg border border-gray-200 overflow-hidden text-xs">
        <button
            type="button"
            onClick={() => onChange('axis')}
            className={`px-3 py-1.5 transition-colors ${value === 'axis' ? 'bg-gray-800 text-white' : 'hover:bg-gray-50 text-gray-600'}`}
        >
            Axis
        </button>
        <button
            type="button"
            onClick={() => onChange('vtech')}
            className={`px-3 py-1.5 transition-colors ${value === 'vtech' ? 'bg-gray-800 text-white' : 'hover:bg-gray-50 text-gray-600'}`}
        >
            V-Tech
        </button>
    </div>
);

export default LogoToggle;